/**
 * Notification utility functions using SweetAlert2 (https://sweetalert2.github.io/)
 */


import Swal from "sweetalert2";


export const notificacaoAlert = (titulo, texto, iconTipo, tempo) => {
    Swal.fire({
        title: `${titulo}`,
        html: `${texto}`,
        icon: `${iconTipo}`,
        showConfirmButton: false,
        timer: tempo ?? 3000,
        timerProgressBar: true,
    });
};



export const notificacaoAlertConfim = (titulo, texto, iconTipo) => {
    Swal.fire({
        title: `${titulo}`,
        html: `${texto}`,
        icon: `${iconTipo}`,
        confirmButtonText: "OK",
    });
};
